
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";

interface OfferMetricsProps {
  dr: number;
  da: number;
  trafficEstimate: number;
  sampleLinks?: string[];
  requirements?: string[];
}

const OfferMetrics = ({
  dr,
  da,
  trafficEstimate,
  sampleLinks,
  requirements
}: OfferMetricsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Site Metrics</CardTitle>
        <CardDescription>
          Key performance indicators for this backlink opportunity
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="flex flex-col items-center p-4 bg-primary/5 rounded-lg">
            <div className="text-xs font-medium text-gray-500 mb-1">Domain Rating</div>
            <div className="text-3xl font-bold text-primary">{dr || "N/A"}</div>
          </div>
          <div className="flex flex-col items-center p-4 bg-primary/5 rounded-lg">
            <div className="text-xs font-medium text-gray-500 mb-1">Domain Authority</div>
            <div className="text-3xl font-bold text-primary">{da || "N/A"}</div>
          </div>
          <div className="flex flex-col items-center p-4 bg-primary/5 rounded-lg">
            <div className="text-xs font-medium text-gray-500 mb-1">Monthly Traffic</div>
            <div className="text-3xl font-bold text-primary">
              {trafficEstimate ? trafficEstimate.toLocaleString() : "N/A"}
            </div>
          </div>
        </div>
        
        {sampleLinks && sampleLinks.length > 0 && (
          <div className="mt-8">
            <h3 className="text-sm font-semibold mb-3">Sample Published Links</h3>
            <div className="space-y-2">
              {sampleLinks.map((link, index) => (
                <a 
                  key={index} 
                  href={link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-blue-600 hover:underline"
                >
                  <ExternalLink className="h-4 w-4" />
                  {link.replace(/^https?:\/\//i, '')}
                </a>
              ))}
            </div>
          </div>
        )}

        {requirements && requirements.length > 0 && (
          <div className="mt-6">
            <h3 className="font-semibold mb-2">Requirements:</h3>
            <ul className="list-disc list-inside space-y-1">
              {requirements.map((req, index) => (
                <li key={index}>{req}</li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OfferMetrics;
